import urlConfig from '@/Configurations/urlConfig';
import { EventListDict, InterfaceSend, StudentTestDeviceIF, SendParams, SendParamItem } from '@/interfaces/wsInterface';
import store from '@/store';
import { InterfaceLiveRecordItem } from '@/apis/onlineLive';
import hashFnv32a from './hash';
import { activeHudong } from './common';
import router from '@/router';
import attendanceBlacklist from '@/Configurations/attenceBlacklist';

class WebsocketCourse {
  private timeOut = 25000; // 心跳时间25秒
  private websocketInstance!: WebSocket;
  private heartTimer = -1; // 心跳定时器
  private courseCounterHeartTimer = -1; // 学生学习了多长时间的心跳timer
  private closeWebsocket: boolean = false; // 是否主动关闭ws
  private pauseWebsocket: boolean = false; // 暂停ws
  private url = `${urlConfig.websocketRequestUrl}`;
  private hashStr: string = '';
  public status: number = 3; // 0，表示正在连接。1，表示连接成功，可以通信了。2，表示连接正在关闭。3，表示连接已经关闭，或者打开连接失败。
  private sendQueue: { data: SendParamItem; cmd: keyof SendParams }[] = [];
  // 消息回调数组，存放观察者模式
  public callBackList: object[] = [];

  private reConnectTime: number = 5; // 重连次数
  private reConnectTimer: number = -1 // 重连定时器
  private courseId: string = '';
  private token: string = '';

  // 待下发的回调
  eventList: EventListDict = {
    'System.pong': () => {
      // console.log("心跳")
    },
    'User.error': (msg: string) => {
      // 现在多设备登陆不踢了， user.error不会再出现
      // console.error(msg);
      // this.setHash(true);
      // this.init();
    } // 用户被挤下线
  };
  constructor() {
    // websocket兼容性判断
    window.wsAppModule = this;
    if (!this.websocketInstance && 'WebSocket' in window) {
      if (!localStorage.getItem('token')) {
        console.error('no token when connecting to /teach websocket interface.Function init() exit.');
        return;
      }
      this.setHash();
      this.startInstance();
    } else if (!('WebSocket' in (window as any))) {
      (window as any).alert('您的浏览器不支持WebSocket');
    }
  }
  init() {
    if (this.status !== 3) return;
    this.setHash();
    this.websocketInstance = new WebSocket(this.url, [this.token, this.hashStr]);
    this.status = this.websocketInstance.readyState;
    // this.websocketInstance = new WebSocket(this.url, [token]);
    // 心跳
    this.websocketInstance.onopen = () => {
      console.log('websocket onopen,websocket 连接成功');
      this.status = this.websocketInstance.readyState;
      this.heartPindAtOnce();
      // 连接成功后，执行队列

      const queue = () => {
        this.send(this.sendQueue.shift());
        if (this.sendQueue.length) {
          queue();
        }
      };
      console.log('quene ok');
      if (this.sendQueue.length) {
        queue();
      }
      // this.heartStart()
    };
    this.websocketInstance.onmessage = arg => {
      // console.log(arg);
      this.status = this.websocketInstance.readyState;
      this.onMessage(arg);
    };
    this.websocketInstance.onerror = (arg: Event) => {
      console.log('websocket onerror');

      this.status = this.websocketInstance.readyState;
      this.onError(arg);
    };
    this.websocketInstance.onclose = (arg: CloseEvent) => {
      console.log('websocket onclosed,close event is:', arg);

      this.status = this.websocketInstance.readyState;
      this.onClose(arg);
    };
    document.onvisibilitychange = () => {
      if (document.visibilityState === 'visible') {
        this.pauseWebsocket = false;
      } else if (document.visibilityState === 'hidden') {
        this.pauseWebsocket = true;
      }
      console.log('vschange,ws开始重连', document.visibilityState);
      this.reConnect();
    };
  }
  on(key: keyof EventListDict, cb: (data: any) => void) {
    if (sessionStorage.getItem('courseId')) {
      // this.eventList[key] = cb;
      this.callBackList.push({
        key,
        cb
      });
    } else {
      this.closeInstance();
    }
  }
  remove(key: keyof EventListDict) {
    // delete this.eventList[key];
    for (let i = 0; i < this.callBackList.length; i++) {
      // @ts-ignore
      if (this.callBackList[i].key === key) {
        this.callBackList.splice(i, 1);
      }
    }
  }
  send(data: SendParamItem, cmd: keyof SendParams = 'AttendClass.commonBroadcast') {
    if (sessionStorage.getItem('courseId')) {
      // 上报消息
      if (data.cmd) {
        this.send(data.data, data.cmd);
      } else {
        const sendData = {
          cmd,
          data
        };
        if (this.status === 1) {
          this.websocketInstance.send(JSON.stringify(sendData));
        } else {
          // 若未连接wesocket，存入队列
          this.sendQueue.push(sendData);
        }
      }
    } else {
      // 未进入课堂，关闭ws
      this.closeInstance();
    }
  }
  startInstance() {
    this.token = localStorage.getItem('token') ?? '';
    this.courseId = sessionStorage.getItem('courseId') ?? '';
    let nTime: number = 0;
    if (this.reConnectTimer !== undefined && this.reConnectTimer !== -1) {
      clearInterval(this.reConnectTimer);
    }
    this.reConnectTimer = setInterval(() => {
      nTime += 1;
      if (this.status === 1) {
        console.log('连接正常，无需重连');
        clearInterval(this.reConnectTimer);
      } else if (this.courseId && this.token) {
        console.log('连接中');
        this.init();
        clearInterval(this.reConnectTimer);
      } else {
        //console.error('没有课程id或者token');
        this.courseId = sessionStorage.getItem('courseId') ?? '';
      }
      if (nTime === this.reConnectTime) {
        clearInterval(this.reConnectTimer);
        // console.log(`已重连${nTime}次，不再重连`);
      }
    }, 10000);
  }
  closeInstance() {
    this.closeWebsocket = true;
    this.heartStop();
    const timer = setInterval(() => {
      if (this.status === 3) {
        clearInterval(timer);
      } else {
        this.websocketInstance.close();
      }
    }, 100);
  }
  onMessage(resData: MessageEvent) {
    // 接收成功一次推送，就将心跳检测的倒计时重置为10秒
    this.heartReset();
    const res: { cmd: keyof EventListDict; code: number; msg: string; data: object } = JSON.parse(resData.data);
    //console.log(res);
    // const cb = this.eventList && this.eventList[res.cmd];
    // if (typeof cb === 'function') {
    //   if (res.code === -1) {
    //     cb(res.msg);
    //   } else {
    //     cb(res.data);
    //   }
    // } else {
    //   // console.error('no function registed')
    // }
    for (let i = 0; i < this.callBackList.length; i++) {
      const callbackItem: any = this.callBackList[i];
      if (res.cmd === callbackItem.key) {
        const { cb } = callbackItem;
        if (typeof cb === 'function') {
          if (res.code === -1) {
            cb(res.msg);
          } else {
            cb(res.data);
          }
        }
      }
    }
  }
  onClose(arg: CloseEvent) {
    console.error('onclose function close event is:', arg);
    if (this.closeWebsocket || this.pauseWebsocket) {
      // 主动关闭时，不做操作
      // this.reConnect();
    } else {
      this.reConnect();
    }
  }
  onError(arg: Event) {
    console.error('on error function call:', arg);
  }
  reConnect() {
    this.startInstance();
  }
  heartStart() {
    // 启动心跳检测机制，设置倒计时25秒一次
    this.heartTimer = setTimeout(() => {
      if (sessionStorage.getItem('classTimeId') || sessionStorage.getItem('courseId')) {//心跳上报改为进入课程就上报
        this.sendCourseHeart();
      } else {
        const message = {
          cmd: 'ping',
          data: 10
        };
        this.websocketInstance.send(JSON.stringify(message));
      }
    }, this.timeOut);
  }
  heartStop() {
    // 关闭心跳
    if (this.heartTimer !== -1) {
      clearInterval(this.heartTimer);
      this.heartTimer = -1;
    }
    this.clearIntervalCourseCounter();
  }
  // 发起第一次心跳，并且注册全局考勤和互动事件
  heartPindAtOnce() {
    const courseId = sessionStorage.getItem('courseId');
    const classTimeId = sessionStorage.getItem('classTimeId');
    // 课堂小结有的情况下
    if (courseId && classTimeId ) {
      // 上课心跳 学习时长，此时保持心跳可以不发
      this.sendCourseHeart({
        classId: courseId,
        classTimeId,
        courserole: 0
      });
      this.startIntervalCourseCounter({
        classId: courseId,
        classTimeId,
        courserole: 0
      });
    } else {
      // 保持ws连接的心跳
      const message = {
        cmd: 'ping',
        data: 10
      };
      this.websocketInstance.send(JSON.stringify(message));
    }
    // 调取接口获取当前考勤
    if(!attendanceBlacklist.includes(router.currentRoute.path)) {
      let courseid = sessionStorage.getItem('courseId');
      if(courseid != "0" && courseid != ""){
        store.dispatch('getNotFinishAttenceStudent', { courseId: courseid }); 
      }
    }
    this.on('KeTangPaiPublishAttendance', () => {
      let courseid = sessionStorage.getItem('courseId');
      if(courseid != "0" && courseid != ""){
        store.dispatch('getNotFinishAttenceStudent', { courseId: courseid });
      }
    });
    // 判断是否已注册
    let registry = false;
    for (let i = 0; i < this.callBackList.length; i++) {
      const callbackItem: any = this.callBackList[i];
      if (callbackItem.key === 'addRecord') {
        registry = true;
      }
    }
    if (!registry) {
      // 注册互动事件
      this.on('addRecord', (res: InterfaceLiveRecordItem) => {
        if (res.recordStatus) {
          activeHudong([res]);
        }
      });
    }
  }
  heartReset() {
    clearTimeout(this.heartTimer); // 重置倒计时
    this.heartStart();
  }
  sendCourseCounter(data: any) {
    const msg = {
      cmd: 'AttendClass.setActive',
      data
    };
    // 判断ws 受否链接
    if(this.status === 1) {
      this.websocketInstance.send(JSON.stringify(msg));
    } else {
      this.startInstance()
    }
  }
  sendCourseHeart(data?: { classId: string; classTimeId: string; courserole: number }) {
    if (!data) {
      const courseId = sessionStorage.getItem('courseId') as string;
      const classTimeId = sessionStorage.getItem('classTimeId') as string;
      data = {
        classId: courseId,
        classTimeId,
        courserole: 0
      };
    }
    this.sendCourseCounter(data);
  }
  startIntervalCourseCounter(data: any) {
    if (this.courseCounterHeartTimer === -1 || this.courseCounterHeartTimer === undefined) {
      this.courseCounterHeartTimer = setInterval(
        // eslint-disable-next-line no-shadow
        (data: any) => {
          data.classTimeId = sessionStorage.getItem('classTimeId');
          this.sendCourseCounter(data);
        },
        25000,//25秒发一次即可
        data
      );
    }
  }
  clearIntervalCourseCounter() {
    if (this.courseCounterHeartTimer !== -1 && this.courseCounterHeartTimer !== undefined) {
      clearInterval(this.courseCounterHeartTimer);
    }
  }
  setHash(reset?: boolean) {
    if (reset || localStorage.getItem('wsHash') === null) {
      const token = localStorage.getItem('token') as string;
      this.hashStr = hashFnv32a(token + new Date().getTime(), true) as string;
    } else {
      this.hashStr = localStorage.getItem('wsHash') as string;
    }
    localStorage.setItem('wsHash', this.hashStr);
  }
}

export default new WebsocketCourse()
